import { defaultDesign, PALETTES, statsFor } from "./shield";

export const KIDS = {
  gaa: { id: "5353870c-0699-48ef-aeb1-72cc74c90809", w: 848, h: 1264 },
  football: { id: "5cf39cdd-37ad-4ea0-99fb-5b79124e9327", w: 848, h: 1264 },
  rugby: { id: "a6449fa2-974b-4d38-a61a-cb99f1b31e42", w: 848, h: 1264 },
  hurling: { id: "167b16a9-cc69-4a6e-a3d2-7a3d7f0db0e1", w: 848, h: 1264 },
  camogie: { id: "e691e946-c5a8-43c6-8149-2dc39b77b3d6", w: 848, h: 1264 },
  hurling2: { id: "3c30f046-42ee-4fa3-bc66-400600757b65", w: 848, h: 1264 },
  rugbyGirl: { id: "b88a9afa-d9fa-4f86-8692-92e3ed89ba29", w: 848, h: 1264 },
};
const colours = (id) => { const { id: _, name, ...c } = PALETTES.find((p) => p.id === id); return c; };
const stats = (sport, vals) => Object.fromEntries(statsFor(sport).map((s, i) => [s.key, String(vals[i])]));

export const AI_BGS = {
  lightning: { id: "9510f7cf-e921-4f8b-9e76-8d7a482fbb26", w: 848, h: 1264 },
  galaxy: { id: "aa00d64a-68e6-4aa8-9783-5e37f18b1b4c", w: 848, h: 1264 },
  graffiti: { id: "6aca015a-b2fb-4b6c-8ffe-6701235aecf3", w: 848, h: 1264 },
};

const make = ({ county, province, kid, sport, palette, style, variant, name, rating, position, club, vals, blend, x = 18, shirt = "", bg }) => {
  const d = defaultDesign();
  return {
    ...d, sport, guide: false, colours: colours(palette),
    background: { ...d.background, style: bg ? "upload" : style, variant: variant || d.background.variant, upload: bg ? { ...d.background.upload, file: AI_BGS[bg] } : d.background.upload },
    photo: { ...d.photo, file: KIDS[kid || sport], zoom: 1.15, x, y: 42, fade: true, blend: blend || "normal", blendStrength: 0.55 },
    player: { ...d.player, name, rating: String(rating), position: "custom", customPosition: position, clubName: club, shirtNumber: shirt },
    stats: stats(sport, vals),
    flag: county || province ? { ...d.flag, kind: county ? "county" : "province", county: county || d.flag.county, province: province || d.flag.province } : d.flag,
  };
};

export const SAMPLES = [
  { ...make({ county: "lim", sport: "gaa", palette: "green-white", style: "stripes", variant: "vertical", name: "Aoife Kelly", rating: 84, position: "MID", club: "", vals: [86, 82, 79, 88, 71, 90], x: -10 }), layout: "row" },
  make({ sport: "football", palette: "navy-gold", shirt: "9", style: "abstract", name: "Seán Murphy", rating: 91, position: "DEF", club: "Shamrock Rovers U12", vals: [94, 89, 81, 90, 42, 77] }),
  make({ province: "mun", sport: "rugby", palette: "red-white", style: "geometric", name: "Jack O'Brien", rating: 79, position: "CAM", club: "Munster Minis", vals: [78, 88, 74, 61, 85, 82] }),
];

export const SPORT_SAMPLES = {
  hurling: [
    make({ county: "gal", sport: "hurling", kid: "hurling", palette: "maroon-white", style: "stripes", variant: "vertical", name: "Cian Fahy", rating: 87, position: "CHF", club: "Clarinbridge U12", vals: [84, 90, 78, 82, 76, 91] }),
    make({ county: "dub", sport: "hurling", kid: "camogie", palette: "blue-white", style: "geometric", name: "Ella Byrne", rating: 89, position: "MF", club: "St Vincent's Camogie", vals: [88, 92, 81, 86, 70, 93] }),
    make({ county: "kik", sport: "hurling", kid: "hurling2", palette: "black-amber", style: "abstract", name: "Darragh Ryan", rating: 82, position: "FB", club: "Kilkenny Minors", vals: [79, 83, 72, 80, 88, 85] }),
  ],
  rugby: [
    make({ province: "mun", sport: "rugby", palette: "red-white", style: "geometric", name: "Jack O'Brien", rating: 79, position: "FH", club: "Munster Minis", vals: [78, 88, 74, 61, 85, 82] }),
    make({ province: "lei", sport: "rugby", kid: "rugbyGirl", palette: "navy-gold", style: "abstract", name: "Sadhbh Walsh", rating: 85, position: "N8", club: "Leinster Juniors", vals: [80, 91, 77, 58, 90, 84] }),
  ],
};

export const AI_SAMPLES = [
  make({ sport: "football", palette: "red-white", bg: "lightning", shirt: "7", name: "Liam Doyle", rating: 92, position: "ST", club: "Rovers U12", vals: [93, 90, 84, 91, 45, 78] }),
  make({ sport: "rugby", kid: "rugbyGirl", palette: "navy-gold", bg: "galaxy", name: "Ava Lynch", rating: 88, position: "N8", club: "Galaxy Girls U11", vals: [88, 85, 90, 87, 60, 80] }),
  make({ sport: "gaa", palette: "black-amber", bg: "graffiti", name: "Orla Hayes", rating: 86, position: "FWD", club: "Street Stars", vals: [86, 84, 80, 89, 70, 85] }),
];
